"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _events = _interopRequireDefault(require("../../utils/helpers/events"));

var _iconButton = _interopRequireDefault(require("./icon-button.style"));

var _icon = _interopRequireDefault(require("../icon"));

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const IconButton = /*#__PURE__*/_react.default.forwardRef(({
  "aria-label": ariaLabel,
  onAction,
  children,
  ...rest
}, ref) => {
  const marginProps = (0, _utils.filterStyledSystemMarginProps)(rest);

  const onKeyDown = e => {
    if (_events.default.isEnterKey(e) || _events.default.isSpaceKey(e)) {
      e.preventDefault();
      onAction(e);
    } else {
      e.stopPropagation();
    }
  };

  const handleOnAction = e => {
    onAction(e);
  };

  return /*#__PURE__*/_react.default.createElement(_iconButton.default, _extends({}, rest, {
    "aria-label": ariaLabel,
    onKeyDown: onKeyDown,
    onClick: handleOnAction,
    ref: ref
  }, marginProps), children);
});

IconButton.propTypes = { ...marginPropTypes,

  /** Children prop is restricted to one Icon Component */
  children: _propTypes.default.shape({
    type: _propTypes.default.oneOf([_icon.default, _propTypes.default.element])
  }).isRequired,

  /** Callback */
  onAction: _propTypes.default.func.isRequired,

  /** Prop to specify the aria-label of the icon-button component */
  "aria-label": _propTypes.default.string
};
var _default = IconButton;
exports.default = _default;